import { render, staticRenderFns } from "./CommunityLinks.vue?vue&type=template&id=01846109&scoped=true&"
import script from "./CommunityLinks.vue?vue&type=script&lang=js&"
export * from "./CommunityLinks.vue?vue&type=script&lang=js&"
import style0 from "./CommunityLinks.vue?vue&type=style&index=0&id=01846109&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01846109",
  null
  
)

export default component.exports